// extracted by mini-css-extract-plugin
export default {"mu-select":"Select_mu-select__pATOu"};